import React, { useEffect, useRef, useState } from "react";
import "./Acknowledgement.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import acknowledgement from "../../../src/assets/Images/acknowledgement.jpeg";

const Acknowledgement = () => {
  const [scrolled, setScrolled] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !scrolled) {
          setScrolled(true);
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, options);
    if (cardRef.current) {
      observer.observe(cardRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [scrolled]);

  return (
    <div className="ackWrapper" ref={cardRef}>
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          boxShadow: "none",
          minWidth: 345,
          maxWidth: "91%",
          minHeight: 400,
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: "8px",
          background: "#352475",
        }}
      >
        <CardMedia
          component="img"
          alt="Acknowledgement"
          height="155"
          image={acknowledgement}
          style={{ marginLeft: "15px", width: "98%", flex: "1 1" }}
        />
        <CardContent>
          <div className={`scrollingTextRtl ${scrolled ? "scrolled" : ""}`}>
            <Typography
              className="acknowledgementLabel"
              variant="body2"
              color="gba(54,54,54,1)"
            >
              I, Christopher Aguilar, have built and donated this educational resource page to Saint Catherine Academy’s Language Department. Its purpose is to continue the work of the Sisters of Mercy through Catholic education with a tradition of academic excellence, concern for women and women’s issues, compassionate service to the poor, spiritual growth and development, and world vision and responsibility. The project demonstrates the resilience and determination of the language department during the Covid-19 pandemic to ensure the uninterrupted delivery of remote instruction. The dedicated teachers at SCA utilized their technological skills to produce instructional videos, capturing the essence of the lessons and enabling continued learning for students in the new online learning environment. Leveraging their expertise, along with open-source web resources and video editing platforms, they created a valuable educational tool which is now readily available as they continue to engage in teaching and learning experiences using the Microsoft Teams platform. Extended gratitude and appreciation are bestowed on these teachers who spent countless hours crafting these videos which will continue to enhance their classroom experiences with innovative technological solutions.
            </Typography>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Acknowledgement;
